import React from 'react';
import { TiArrowSortedUp, TiArrowSortedDown } from 'react-icons/ti';
import style from './tableStyles.module.scss';

export const TableColumnHeader = ({
  children,
  currentSortField,
  isCurrentSortOrderDescending,
  colId,
  onClickHandler,
  className,
}) => {
  const willResetSorting =
    currentSortField === colId && isCurrentSortOrderDescending === false;

  const getIsSortOrderDescending = () => {
    if (willResetSorting) {
      return null;
    }

    if (currentSortField === colId) {
      return !isCurrentSortOrderDescending;
    }

    return true;
  };

  const getColId = () => {
    if (willResetSorting) {
      return null;
    }

    return colId;
  };

  return (
    <button
      type="button"
      className={className || style.columnHeader}
      onClick={() => onClickHandler(getColId(), getIsSortOrderDescending())}
    >
      <div>{children}</div>
      {currentSortField === colId && (
        <div className={style.columnHeaderSortingIcon}>
          {isCurrentSortOrderDescending && <TiArrowSortedDown />}
          {!isCurrentSortOrderDescending && <TiArrowSortedUp />}
        </div>
      )}
    </button>
  );
};
